import React from "react";
import { useLocation } from "react-router-dom";
import SEOHelmet from "./SEOHelmet";
import { getSeoForPath } from "../seo/routeSeo";

/**
 * Applies title, meta description, keywords, and canonical from the central route map.
 */
const SeoFromRoute = () => {
  const { pathname } = useLocation();
  const seo = getSeoForPath(pathname);

  return (
    <SEOHelmet
      title={seo.title}
      description={seo.description}
      keywords={seo.keywords}
      canonicalPath={seo.canonicalPath}
      ogImagePath={seo.ogImagePath}
      ogType={seo.ogType}
      twitterCard={seo.twitterCard}
    />
  );
};

export default SeoFromRoute;
